{
  "achievements": "اچیومنٹس",
  "advanced": "ایڈوانس",
  "all": "تمام",
  "antiFakeProtection": "فراڈ مخالف تحفظ",
  "antiFakeProtectionText": "دھوکہ دہی کی سرگرمی روکنے کے لیے تمام دعوے سرور کی سطح پر تصدیق شدہ ہوتے ہیں۔",
  "approvedClaims": "منظور شدہ دعوے",
  "approvedExalt": "منظور شدہ EXALT",
  "beginner": "ابتدائی",
  "claim5Exalt": "5 EXALT حاصل کریں",
  "claimDailyMining": "روزانہ کان کنی انعام کا دعویٰ کریں",
  "claimDailyRewardDesc": "اپنا روزانہ 5 EXALT انعام حاصل کریں۔",
  "claimDailyRewardDescription": "روزانہ 5 EXALT حاصل کریں۔",
  "claimFailed": "دعویٰ ناکام ہو گیا۔",
  "claimedToday": "آج وصول ہو چکا",
  "completed": "مکمل",
  "completedTasks": "مکمل اسباق",
  "cooldown": "کول ڈاؤن",
  "correctAnswerRewardAdded": "صحیح جواب! انعام شامل کر دیا گیا۔",
  "cryptoBasics": "کرپٹو کی بنیادی معلومات",
  "dailyMiningRate": "روزانہ کان کنی کی شرح",
  "dailyReward": "روزانہ انعام",
  "dailyRewardClaimed": "روزانہ انعام حاصل کر لیا گیا۔",
  "dailyStreak": "ڈیلی اسٹریک",
  "days": "دن",
  "distributed": "تقسیم شدہ",
  "downloadCertificate": "سرٹیفکیٹ ڈاؤن لوڈ کریں",
  "duration": "دورانیہ",
  "exaltExchangeUser": "Exalt Exchange صارف",
  "exaltMiningPool": "EXALT کان کنی پول",
  "failedLoadRewards": "انعامات لوڈ کرنے میں ناکامی۔",
  "firstLesson": "پہلا سبق",
  "intermediate": "درمیانہ",
  "learnEarn": "سیکھیں اور کمائیں",
  "learnEarnSubtitle": "ویڈیوز دیکھیں، کوئز مکمل کریں اور EXALT انعام حاصل کریں۔",
  "learnEarnTitle": "سیکھیں اور کمائیں",
  "learnerAchievement": "سیکھنے والے کی کامیابی",
  "learningLevel": "سیکھنے کی سطح",
  "learningProgress": "سیکھنے کی پیشرفت",
  "lessonCompleted": "سبق کامیابی سے مکمل ہوگیا۔",
  "level": "لیول",
  "loadingLessons": "اسباق لوڈ ہو رہے ہیں...",
  "locked": "Locked",
  "masterAchievement": "ماہر کی کامیابی",
  "miningProtectionNote": "کان کنی کے انعامات خودکار اور نقلی دعووں سے محفوظ ہیں۔",
  "miningRewardSubmitted": "کان کنی انعام کا دعویٰ جمع کرا دیا گیا۔",
  "myRewardClaims": "میرے انعام کے دعوے",
  "noAchievements": "ابھی کوئی اچیومنٹ نہیں",
  "noActivityYet": "ابھی کوئی سرگرمی نہیں",
  "noMinersYet": "ابھی تک کوئی کان کن نہیں۔",
  "noReferrersYet": "ابھی تک کوئی ریفرر نہیں۔",
  "noRewardClaimsYet": "ابھی تک کوئی انعام کا دعویٰ نہیں۔",
  "oneClaimEvery24Hours": "ہر 24 گھنٹے میں ایک دعویٰ کی اجازت ہے۔",
  "optionAfterPayment": "ادائیگی کی تصدیق کے بعد",
  "optionAnyTime": "کبھی بھی",
  "optionBeforePayment": "ادائیگی سے پہلے",
  "optionDeleteTokens": "کوائن حذف کرنا",
  "optionLockTokens": "ریوارڈ کے لیے کوائن لاک کرنا",
  "optionPrivateKey": "پرائیویٹ کی شیئر کریں",
  "optionProtectWallet": "والیٹ کیز محفوظ رکھیں",
  "optionSendTokens": "کوائن بھیج دینا",
  "optionUnknownLinks": "نامعلوم لنکس استعمال کریں",
  "p2pSafety": "P2P حفاظت",
  "pendingValue": "زیر التوا قیمت",
  "questionCrypto": "کرپٹو میں سب سے محفوظ اصول کیا ہے؟",
  "questionP2p": "P2P میں کرپٹو کب جاری کرنی چاہیے؟",
  "questionStaking": "اسٹیکنگ کا مطلب کیا ہے؟",
  "quiz": "کوئز",
  "recentActivity": "حالیہ سرگرمی",
  "referralRewardNote": "ریفرل انعامات ایڈمن کی تصدیق کے بعد جمع ہوتے ہیں۔",
  "referralRewardPool": "ریفرل انعام پول",
  "referrals": "ریفرلز",
  "reward": "ریوارڈ",
  "rewardClaim": "انعام کا دعویٰ",
  "rewardClaimFailed": "ری وارڈ کلیم ناکام ہوگیا۔",
  "rewardClaimed": "ری وارڈ کامیابی سے کلیم ہوگیا۔",
  "rewardCompleted": "انعام مکمل ہو گیا۔",
  "rewardFailed": "انعام کا دعویٰ ناکام ہو گیا۔",
  "searchLessons": "اسباق تلاش کریں...",
  "securityReview": "سیکیورٹی جائزہ",
  "serverError": "سرور میں خرابی۔",
  "sessionExpired": "سیشن ختم ہو گیا۔ براہ کرم دوبارہ لاگ ان کریں۔",
  "stakingGuide": "اسٹیکنگ گائیڈ",
  "startLesson": "سبق شروع کریں",
  "submitQuizClaimReward": "کوئز جمع کریں اور انعام حاصل کریں",
  "submitting": "جمع کیا جا رہا ہے...",
  "todayClaims": "آج کے دعوے",
  "topLearners": "ٹاپ لرنرز",
  "topMiners": "سرکردہ کان کن",
  "topReferrers": "سرکردہ ریفررز",
  "totalClaims": "کل دعوے",
  "totalPool": "کل پول",
  "totalRewards": "کل انعامات",
  "used": "استعمال شدہ",
  "videoCryptoBasics": "کرپٹو کیا ہے اور ایکسچینج کیسے کام کرتی ہے؟",
  "videoP2pSafety": "P2P صارفین کے ساتھ محفوظ تجارت کیسے کریں",
  "videoStakingGuide": "اسٹیکنگ ریوارڈز کیسے کام کرتے ہیں",
  "viewAgain": "دوبارہ دیکھیں",
  "wrongAnswerTryAgain": "غلط جواب، دوبارہ کوشش کریں۔",
  "xpPoints": "XP پوائنٹس",
  "you": "آپ"
}